import {Action} from '@ngrx/store';

import {IDeviceMinAvg} from '../../../dashboard/shared';
import {Device} from '../../../afb-api/models/device';

/* Before requesting the air data */
export const UPDATE_AIR_DATA = '[Air Data] Update Air Data';
export const UPDATE_DEVICE_LIST = '[Air Data] Update Device List';
export const UPDATE_DEVICE_LIST_FAIL = '[Air Data] Update Device List Fail';
export const UPDATE_TIME_RANGE = '[Air Data] Update Time Range';
export const UPDATE_TIME_RANGE_FAIL = '[Air Data] Update Time Range Fail';

export const START_LOADING = '[Air Data] Start Loading';
export const CLEAR_AIR_DATA = '[Air Data] Clear Air Data';

export const REQUEST_AIR_DATA = '[Air Data] Request Air Data';
export const REQUEST_SUCCESS = '[Air Data] Request Success';
export const REQUEST_FAIL = '[Air Data] Request Fail';

/**
 * Update Actions from Host
 */
export class UpdateAirDataAction implements Action {
  readonly type = UPDATE_AIR_DATA;

  constructor(public payload: {
    orgToken: string,
    selectedDeviceList: Device[],
    interval: number,
    fromDate: Date,
    toDate: Date,
    desc?: boolean,
    limit?: number
  }) {
  }
}

export class UpdateDeviceListAction implements Action {
  readonly type = UPDATE_DEVICE_LIST;

  constructor(public payload: { orgToken: string, selectedDeviceList: Device[] }) {
  }
}

export class UpdateDeviceListFailAction implements Action {
  readonly type = UPDATE_DEVICE_LIST_FAIL;

  constructor() {
  }
}

export class UpdateTimeRangeAction implements Action {
  readonly type = UPDATE_TIME_RANGE;

  constructor(public payload: { orgToken: string, fromDate: Date, toDate: Date }) {
  }
}

export class UpdateTimeRangeFailAction implements Action {
  readonly type = UPDATE_TIME_RANGE_FAIL;

  constructor() {
  }
}

/**
 * Loading
 */
export class StartLoadingAction implements Action {
  readonly type = START_LOADING;

  constructor() {
  }
}

export class ClearAirDataAction implements Action {
  readonly type = CLEAR_AIR_DATA;

  constructor() {
  }
}

/**
 * HTTP request for Air Data
 */
export class RequestAirDataAction implements Action {
  readonly type = REQUEST_AIR_DATA;

  constructor(public payload: {
    orgToken: string, selectedDeviceUuidList: string[], interval: number, fromDate: Date, toDate: Date,
    desc?: boolean, limit?: number
  }) {
  }
}

export class RequestSuccessAction implements Action {
  readonly type = REQUEST_SUCCESS;

  constructor(public payload: {
    entities: { [deviceUuid: string]: IDeviceMinAvg[] },
    timeRange: { fromDate: Date, toDate: Date }
  }) {
  }
}

export class RequestFailAction implements Action {
  readonly type = REQUEST_FAIL;

  constructor() {
  }
}

/**
 * Export a type alias of all actions in this action group
 * so that reducers can easily compose action types
 */
export type Actions
  // Updates
  = UpdateAirDataAction
  | UpdateDeviceListAction
  | UpdateDeviceListFailAction
  | UpdateTimeRangeAction
  | UpdateTimeRangeFailAction
  // Loading
  | StartLoadingAction
  | ClearAirDataAction
  // Requests
  | RequestAirDataAction
  | RequestSuccessAction
  | RequestFailAction;

